import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; // ✅ NUEVO: Firebase Storage

// Pega aquí tu configuración de Firebase desde la consola.
// Se exporta porque `utils/altaUsuarios.js` levanta una segunda instancia con
// la misma configuración para crear cuentas sin tocar la sesión del admin.
export const firebaseConfig = {
  apiKey: "AIzaSyAu95PXBpiqhOQPJgFrL4Xrioh07kUxifk",
  authDomain: "agpformularios.firebaseapp.com",
  projectId: "agpformularios",
  storageBucket: "agpformularios.firebasestorage.app",
  messagingSenderId: "526857400045",
  appId: "1:526857400045:web:de923b29be24608fac26e4",
  measurementId: "G-97HK2EY88C"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app); // ✅ NUEVO: Instancia de Storage

export { db, auth, storage }; // ✅ EXPORTAR: Storage 